export default {
  inactive_doctor: 'طبيب غير مفعل',
  inactive_clinic: 'عيادة غير مفعلة',
  doctors: 'الأطباء',
  clinic_examine: 'كشف عيادة',
  outdoor_examine: 'زيارة ميدانية',
  clinics: 'العيادات',
  hospitals: 'المستشفيات'
}
